jQuery( function($) {       
	$(document).ready( function() {
		
		function heading_parts() {
			
			$('[data-heading-parts]:not(heading-parts-set)').each( function() {
				
				var text  = $(this).text();
				var words = text.split(' ');
				
				if ( words.length > 1 ) {
					
					var first_word = words[0];
					
					words.splice( 0, 1 );
					
					var output = '<span><span class="base-font">' + first_word + '</span> ' + words.join(' ') + '</span>';
					
					$(this).html( output ).addClass('heading-parts-set');
					
				}
				
			});
		}
		
		heading_parts();
		
		
		
		$(document).on( 'updated_checkout', function() {
			
			heading_parts();
		});
		
	});
});

